module.exports = __webpack_public_path__ + "img/education2.d509c109.svg";